import { api } from '@iso/utils/axios.configs';
import { ApiRouters } from '@iso/utils/apiRouters';

export const getAPIBlanksDragDrop = (params) => {
	const url = ApiRouters.API_BLANKS_DRAG_DROP;
	return api.get(url, { params });
};

export const postAPIBlanksDragDrop = (body) => {
	const url = ApiRouters.API_BLANKS_DRAG_DROP;
	return api.post(url, body);
};

export const getAPIBlanksDragDropDetail = (id) => {
	const url = `${ApiRouters.API_BLANKS_DRAG_DROP}/${id}`;
	return api.get(url);
}

export const putAPIBlanksDragDropDetail = (id, body) => {
	const url = `${ApiRouters.API_BLANKS_DRAG_DROP}/${id}`;
	return api.put(url, body);
}

export const deleteAPIBlanksDragDrop = (id) => {
	const url = `${ApiRouters.API_BLANKS_DRAG_DROP}/${id}`;
	return api.delete(url);
};

// export const getReadAloudDetail = (id, params) => {
// 	const url = `${ApiRouters.READALOUD}/${id}`;
// 	return api.get(url, { params });
// };

// export const createQuesReadAloud = (body) => {
// 	const url = ApiRouters.READALOUD;
// 	return api.post(url, body);
// };

// export const updateReadAloudDetail = (body) => {
// 	const url = `${ApiRouters.READALOUD}/${body.id}`;
// 	return api.put(url, body);
// };
